// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#stripes-content
/*всё поле*/ {
  margin-left: 20px;
  margin-right: 20px;
  display: grid;
  padding: 22px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  justify-content: start;
  height: 100vh;
}
.stripes-conteiner {
  display: grid;
  grid-template-columns: 18vw auto;
  gap: 2vh;
  align-items: start;
}



`, "",{"version":3,"sources":["webpack://./src/TaskWindows/StripesApp/styles/StripesApp.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,yDAAgE;EAChE,4EAA4E;EAC5E,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,kBAAkB;AACpB","sourcesContent":["#stripes-content\n/*всё поле*/ {\n  margin-left: 20px;\n  margin-right: 20px;\n  display: grid;\n  padding: 22px;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  justify-content: start;\n  height: 100vh;\n}\n.stripes-conteiner {\n  display: grid;\n  grid-template-columns: 18vw auto;\n  gap: 2vh;\n  align-items: start;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
